import { ReactNode } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

interface ProofCardProps {
  label: string;
  value: ReactNode;
  desc: string;
  source: string;
  inverted?: boolean;
  delay: number;
}

function ProofCard({ label, value, desc, source, inverted, delay }: ProofCardProps) {
  return (
    <div className={`proof-card rv${delay ? ` rv-${delay}` : ''}${inverted ? ' inverted' : ''}`}>
      <div className="proof-label">{label}</div>
      <div className="proof-value">{value}</div>
      <div className="proof-desc">{desc}</div>
      <div className="proof-source">{source}</div>
    </div>
  );
}

function Proof() {
  const { t } = useLanguage();

  return (
    <section className="panel rv-panel">
      <div className="panel-inner">
        <div className="section-head">
          <div className="eyebrow rv">{t.proof.eyebrow}</div>
          <h2 className="section-title rv-clip">{t.proof.heading}</h2>
        </div>
        <div className="proof-grid">
          <ProofCard label={t.proof.p1l} value={<>25<span className="faint">/25</span></>} desc={t.proof.p1d} source="Document Copilot" delay={0} />
          <ProofCard label={t.proof.p2l} value={<>~150<span className="faint">×</span></>} desc={t.proof.p2d} source="Document Copilot" delay={1} />
          <ProofCard label={t.proof.p3l} value={<>2209<span className="acc">-A</span></>} desc={t.proof.p3d} source="KeyStrada" inverted delay={2} />
          <ProofCard label={t.proof.p4l} value={<>2<span className="faint">{t.proof.p4u}</span></>} desc={t.proof.p4d} source="Durmuşlar · Nymu" delay={3} />
        </div>
      </div>
    </section>
  );
}

export default Proof;
